@if(variant !== 'basket') {
<button class="w-12 m-b-2 "
        [class._reducePadding]="reducedSize"
        [buttonStyle]
        [status]="buttonStatus"
        [disabled]="!['instock','nobranch'].includes(state)"
        (click)="submit()">
    {{ (client.isS || variant !== 'PDP' ? 'Collection' : 'Collect') | translate}}
</button>
}
@if (!googleShoppingLayout) {
<div [style.minHeight.px]="15">
    <div class="flex flex-middle flex-justify-center center"
         [ngClass]="[variant === 'PDP' && (client.isX || client.isL) ? 'c1 ': 'c2', stateColor]">
        @if(!reducedSize) {
        <i class="icon-branch m-r-2 icon-medium"></i>
        }
        @switch(state) {
        @case('nobranch') {
        {{ variant === 'PDP' ? 'Select collection branch for local availability' : 'Available for collection' |
        translate }}
        }
        @case('busy') {
        <loader></loader>
        }
        @case('none') {
        <span>{{ 'Not available for collection' | translate}}</span>
        }
        @case('instock') {
        {{variant === 'basket' ? ('Collection available from %' | translate : storeName) : ('% available from %' |
        translate : stockQty : storeName) }}
        }
        @case('limitedstock') {
        <span>{{ 'Only % availbe' | translate : stockQty }}</span>
        }
        @case('outofstock') {
        <span>{{ (variant === 'basket' ? 'Collection unavailable from %' : 'Unavailable from %') |
            translate : storeName}}</span>
        }
        @case('error') {
        <span>{{ 'Error:' | translate }} {{ error || 'Unexpected error' }}</span>
        }
        }
    </div>
</div>

@if(variant === 'PDP' && !['none'].includes(state)) {
<p class="center col-1 m-t-2 m-t-1-s"
   [sizeClass]="'SM: c2, XL: s2'">
    <button (click)="openBranchSelection()"
            [inlineButton]>{{(client.isS ? 'Change' : 'Change Store') | translate}}</button>
</p>
}
}
<result class="block"
        [status]="buttonStatus"></result>
